<template>

  <div>
  <div class="footer" v-if="!isMobile">
    <!-- animate__animated animate__fadeInUp animate__delay-1s -->
    <div class="footer-item ">
      Email: Chuanyueruanjian@163.com<br />
Address: Room 2202, Tower, Shenzhen International Qianhai Yidu Building, No. 99 Gangcheng Street, Nanshan Street, Qianhai<br /> Shenzhen-Hong Kong Cooperation Zone, Shenzhen
    </div>
    <div class="footer-record"> Copyright@ 2025 深圳传悦软件有限公司 All rights reserved </div>
  </div>

  <div class="moreto" v-if="isMobile"> 

    <div class="moreto-top">
      <div class="item">
        <img src="../assets/move/icon_email.png" class="icon"/> 
        <div>Chuanyueruanjian@163.com</div>
      </div>
      <div class="item">
        <img src="../assets//move//icon_adders.png" class="icon" />
        <div> 2202-Tower Building, Qianhai Yidu Mansion, Shenzhen</div>
      </div>
    </div>
    <div class="moreto-flex">Copyright@ 2025 深圳传悦软件有限公司 All rights reserved</div>

  </div>
</div>
</template>

<script>
import {isMobiles}from'../utils/utils'
export default {
  name: 'HelloWorld',
  data() {
    return {
      isMobile:isMobiles()
    };
  },
  created() {

  },
  methods: {

  },
}
</script>

<style lang="scss">
@import 'animate.css';

.footer {
  width: auto;
  height: auto;
  background: #272727;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;

  .footer-item {
    text-align: center;
    line-height: 26px;
    color: #999999;
    font-size: 16px;
    padding: 20px 10px 0;
    z-index: 99;
  }

  .footer-record {
    text-align: center;
    color: #999999;
    line-height: 26px;
    padding-bottom: 20px;
  }
}

@media screen and (min-width: 600px) {
  .footer {}
}

@media screen and (max-width: 600px) {
  .footer {
    height: auto;

    .footer-item {
      text-align: center;
      line-height: 20px;
      color: #999999;
      font-size: 14px;
      padding: 20px 10px 0;

    }

    .footer-record {
      background-color: #1A1A1A;
      line-height: 50px;
    }
  }
}

.moreto{
      color: #999999;
  .moreto-top{
    background-color: #272727;
    padding: 14px 20px;
    .item{
      line-height: 30px;
      font-size: 12px;
      display: flex;
      .icon{
        width: 22px;
        height: 20px;
        position: relative;
        top: 6px;
        margin-right: 4px;
      }
    }

  }
  .moreto-flex{
    background-color: #1A1A1A;
    line-height: 40px;
    font-size: 12px;
    text-align: center;

  }
  
}
</style>
